import { css as d, LitElement as u, html as c } from "lit";
import { property as o, customElement as g } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { b } from "./styles-scZ6dVz-.js";
var v = Object.defineProperty, m = Object.getOwnPropertyDescriptor, i = (e, t, l, s) => {
  for (var r = s > 1 ? void 0 : s ? m(t, l) : t, n = e.length - 1, p; n >= 0; n--)
    (p = e[n]) && (r = (s ? p(t, l, r) : p(r)) || r);
  return s && r && v(t, l, r), r;
};
let a = class extends u {
  constructor() {
    super(...arguments), this.variant = "muted", this.wrap = !0, this.align = "center";
  }
  render() {
    const e = {
      bar: !0,
      wrap: this.wrap,
      [this.variant]: !0,
      [`align-${this.align}`]: !0
    };
    return c`
      <div part="bar" class=${f(e)}>
        <slot></slot>
      </div>
    `;
  }
};
a.styles = [
  b,
  d`
      :host {
        display: block;
      }

      .bar {
        display: flex;
        gap: var(--ark-filter-bar-gap, var(--r5-space-3));
        padding: var(--ark-filter-bar-padding, var(--r5-space-3));
        border-radius: var(--ark-filter-bar-radius, var(--r5-radius-md));
      }

      .wrap {
        flex-wrap: wrap;
      }

      .align-start {
        align-items: flex-start;
      }

      .align-center {
        align-items: center;
      }

      .align-end {
        align-items: flex-end;
      }

      .align-baseline {
        align-items: baseline;
      }

      .muted {
        background: var(--r5-muted);
      }

      .surface {
        background: var(--r5-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--ark-filter-bar-radius, var(--r5-radius-lg));
      }

      .plain {
        background: transparent;
        padding: 0;
      }
    `
];
i([
  o({ type: String, reflect: !0 })
], a.prototype, "variant", 2);
i([
  o({ type: Boolean, reflect: !0 })
], a.prototype, "wrap", 2);
i([
  o({ type: String, reflect: !0 })
], a.prototype, "align", 2);
a = i([
  g("ark-filter-bar")
], a);
export {
  a as A
};
//# sourceMappingURL=ark-filter-bar-D75Y4XxT.js.map
